import { useObject, useSelector } from '_common/hooks';
import { useListNavigationQuery, useListTemplateQuery } from '_common/services/api/realtime';

const useConditionalData = (objectId?: string) => {
  const exportDocumentId = useSelector((state) => state.modals.ExportDocumentModal.objectId);
  const object_id = objectId ?? exportDocumentId;

  //Navigation
  const { data: explorerNavigation } = useListNavigationQuery(object_id);
  const { list: navigationList, data: navigationData } = explorerNavigation ?? {
    list: [],
    data: {},
  };

  //Object
  const { data: object } = useObject({ object_id: object_id, object_type: 'document' });

  //Template
  const { data: explorerTemplate } = useListTemplateQuery(object_id);
  const template = explorerTemplate?.template;

  return { navigationList, navigationData, template, object };
};

export default useConditionalData;
